import { StratumService } from "@capitalone/stratum-observability";
import { PosthogPluginFactory } from "@rachelallyson/stratum-posthog-js";
import { RollbarPluginFactory } from "@rachelallyson/stratum-rollbar-js";

import { EventCatalog } from "./catalog";

import { getRuntimePublicConfig } from "@/lib/runtime-public-config";

const isBrowser = typeof window !== "undefined";
const publicConfig = getRuntimePublicConfig();

// PostHog: only in browser when env vars are set (runtime config, no build-time required)
let posthogPlugin: unknown = null;
const hasPostHogConfig =
  publicConfig.NEXT_PUBLIC_POSTHOG_HOST && publicConfig.NEXT_PUBLIC_POSTHOG_KEY;

if (hasPostHogConfig && isBrowser) {
  try {
    posthogPlugin = PosthogPluginFactory({
      config: { autocapture: false },
      POSTHOG_HOST: publicConfig.NEXT_PUBLIC_POSTHOG_HOST ?? "",
      POSTHOG_KEY: publicConfig.NEXT_PUBLIC_POSTHOG_KEY ?? "",
    });
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error("PostHog plugin initialization error:", error);
    }
  }
} else if (hasPostHogConfig && !isBrowser) {
  console.log(
    "PostHog plugin: Not in browser environment. PostHog will not be initialized.",
  );
}

// Rollbar: when at least one token is set
let rollbarPlugin: unknown = null;
const hasRollbarConfig =
  !!publicConfig.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN ||
  !!process.env.ROLLBAR_SERVER_TOKEN;

// Must match version used when uploading source maps (set at build time in next.config env)
const rollbarCodeVersion =
  process.env.NEXT_PUBLIC_ROLLBAR_CODE_VERSION ?? "1.0.0";

if (hasRollbarConfig) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call -- RollbarPluginFactory from @rachelallyson/stratum-rollbar-js
    rollbarPlugin = RollbarPluginFactory({
      CLIENT_ACCESS_TOKEN: publicConfig.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN ?? "",
      clientConfig: {
        payload: {
          client: {
            javascript: {
              code_version: rollbarCodeVersion,
              source_map_enabled: true,
            },
          },
        },
      },
      config: { environment: process.env.NODE_ENV },
      SERVER_ACCESS_TOKEN: process.env.ROLLBAR_SERVER_TOKEN ?? "",
    });
  } catch (err: unknown) {
    if (process.env.NODE_ENV === "development") {
      console.error("Rollbar plugin initialization error:", err);
    }
  }
}

const plugins: unknown[] = [];

if (posthogPlugin) plugins.push(posthogPlugin);
if (rollbarPlugin) plugins.push(rollbarPlugin);

const stratumService = new StratumService({
  catalog: { items: EventCatalog },
  plugins: plugins as Parameters<StratumService["addPlugin"]>[0],
  productName: "needbridge",
  productVersion: process.env.APP_VERSION ?? "1.0.0",
});

export default stratumService;
